module.exports = __webpack_public_path__ + "static/media/Trainicon03.e911c0e8.png";